export default __webpack_public_path__ + "images/0332d2da4cba9ea1696c9af64feb0be7-chevron-down-bundle-details.svg";